import * as React from "react";
import "./filters.scss";
import {default as Filter, FilterTypeEnum} from "../../../model/workspace/Filter";
import {Option, option} from "ts-option";
import DropDownList from "../../../hiberUiKit/src/molecules/DropDownList/DropDownList";
import FilterButton from "./button/FilterButton";
import DropDownWrapper from "../../../hiberUiKit/src/molecules/DropDownWrapper/DropDownWrapper";
import FilterButtons from "./FilterButtons";
import OptionUtils from "../../../utils/OptionUtils";
import {YesNo} from "../../admin/customFields/BooleanDisplay";

interface IProps {
	filter: Filter
	onChange: (filter: Filter) => void;
	onRemove: (refreshData: boolean) => void;
	isFilterConfigVisible?: boolean;
}

interface IState {
	/**
	 * Filter value
	 */
	value: Option<boolean>
	/**
	 * Indicates if filter config is visible
	 */
	isFilterConfigVisible: boolean
}

export class BooleanFilter extends React.PureComponent<IProps, IState> {

	constructor(props: IProps) {
		super(props);
		this.state = {
			value: this.props.filter.values as Option<boolean>,
			isFilterConfigVisible: props.isFilterConfigVisible,
		};

		this.onCancel = this.onCancel.bind(this);
		this.onDone = this.onDone.bind(this);
	}

	render() {
		return (
			<div>
				<FilterButton filterName={this.props.filter.columnDefinition.label}
							  onRemove={() => this.props.onRemove(true)}
							  onClick={() => this.setState({isFilterConfigVisible: true})}
							  filterValue={this.getFilterValue()}
							  isDisabled={this.state.isFilterConfigVisible}
							  isNegated={this.props.filter.isNegated()}/>
				{
					this.state.isFilterConfigVisible &&
					<DropDownWrapper width={"auto"} onOutsideClick={this.onCancel}>
						<DropDownList items={[false, true]}
									  itemToId={this.itemToId}
									  itemToLabel={this.itemToLabel}
									  onSelect={(item: boolean) => this.setState({value: option(item)})}
									  selectedItemId={this.state.value.map(this.itemToId).orNull}/>
						<FilterButtons onCancel={this.onCancel} onDone={this.onDone} disabled={this.state.value.isEmpty}/>
					</DropDownWrapper>
				}
			</div>
		);
	}

	getFilterValue(): string {
		return (this.props.filter.values as Option<boolean>).map(v => v == true ? YesNo.YES : YesNo.NO).orNull
	}

	itemToId(item: boolean): string {
		return `${item}`;
	}

	itemToLabel(item: boolean): string {
		return item ? YesNo.YES : YesNo.NO;
	}

	onCancel() {
		this.setState({isFilterConfigVisible: false},
			() => this.props.filter.values.isEmpty && this.props.onRemove(false));
	}

	onDone() {
		const filterType = FilterTypeEnum.Equal;
		this.setState({isFilterConfigVisible: false},
			() => this.isFilterChanged(filterType)
				&& this.props.onChange(this.props.filter.copy({values: this.state.value, type: filterType})))
	}

	isFilterChanged(filterType: FilterTypeEnum) {
		return !OptionUtils.isTheSame(this.props.filter.values, this.state.value) || this.props.filter.type !== filterType
	}
}
